<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to Payroll Menu" @click="$router.push('/payroll')">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="payroll" pageId="philhealth-contributions" color="white"></help-link>
                    <v-menu left v-model="menu_status" offset-y> 
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" dark v-on="on">
                                &nbsp;&nbsp;CY {{selectedFiscalYear}}&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense v-for="(item,index) in fiscal_years" :key="index" :title="`Calendar Year ${item.fiscalYear}`">
                            <v-list-tile :key="0" @click="setSelectedYear(item.fiscalYear)">
                                <v-list-tile-title small>CY {{item.fiscalYear}}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-toolbar>
            </v-card>
            <v-card class="elavation-1" style="margin-top:5px;"> 
                <v-toolbar flat height="45px">
                    <div class="wp-30 mb-10">
                        <v-text-field v-model="search" append-icon="search" label="Search month name" single-line hide-details></v-text-field>
                    </div>
                    <v-spacer></v-spacer>
                    <span class="font-weight-bold ">Select month</span>
                </v-toolbar>
                <v-data-table
                    :headers="headers"
                    :items="philhealth_main_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                >
                    <template v-slot:items="props">
                        <tr style="cursor:pointer;" @click="viewDetails(props.item)" title="Click to view details">
                            <td>{{props.item.fiscalYear}}</td>
                            <td>{{props.item.monthName}}</td>
                            <td>
                                <div class="text-xs-right">
                                    {{numFormat.formatNumber(props.item.totalEmployeeContribution)}}
                                </div>
                            </td>
                            <td>
                                <div class="text-xs-right">
                                    {{numFormat.formatNumber(props.item.totalEmployerContribution)}}
                                </div>
                            </td>
                            <td>
                                <div v-if="props.item.paidOn" class="green--text">Paid</div>
                                <div v-else class="orange--text">Unpaid</div>
                            </td>
                            <td>
                                <div v-if="props.item.paidOn">{{ props.item.paidOn | moment("MMM DD, YYYY") }}</div>
                            </td>
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>
        </v-flex>
    </v-layout> 
</template>

<script>

import payrollApi from '@/api/payroll'
import numFormat from '@/common/num_format'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'

export default {     
    name: 'PhilhealthContributionMain',
    metaInfo: {
        title: 'Philhealth Contribution Main',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View Philhealth Contributions' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },   
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)

        return {
            numFormat,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            selectedFiscalYear: userPrefs.getCalendarYear(this.$route.name),
            search: userPrefs.getSearchKeyword(routeName),
            headers: [
                {text: 'Calendar Year',align: 'left',value: 'fiscalYear', width: '10%', sortable:false},
                {text: 'Month',align: 'left',value: 'monthName', width: '20%', sortable:true},
                {text: 'Total Employee Contributions',align: 'right',value: 'totalEmployeeContribution',  width: '20%', sortable:true},
                {text: 'Total Employer Contributions',align: 'right',value: 'totalEmployerContribution',  width: '20%', sortable:true},
                {text: 'Status',align: 'left',value: 'status',  width: '10%', sortable:true},
                {text: 'Paid On',align: 'left',value: 'paidOn',  width: '20%', sortable:true},
            ],
            error: false,
            errorMessage: '',
            loading: false,
            philhealth_summary: [],
            menu_status: false,
        }
    },
    methods: { 
        setSelectedYear(fiscalYear) {
            this.selectedFiscalYear = fiscalYear
            userPrefs.updateCalendarYear(this.$route.name, fiscalYear)
        },  
        viewDetails(data) {
            this.$router.push(`/payroll/philhealth/${data.fiscalYear}/${data.month}`)
        },
        async getPhilhealthMain() {
            try {
                this.loading = true
                const response = await payrollApi.getPhilhealthContributionsSummary()
                if (response && response.status == 200) {
                    this.philhealth_summary = response.data.items

                }
                this.loading = false
            }
            catch(error) {
                this.error = true
                this.errorMessage = error
            }
        },
    },
    created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Philhealth Contributions'
        })

        this.getPhilhealthMain()
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        },
        search(newVal) {
            userPrefs.updateSearchKeyword(this.$route.name, newVal)
        }
    },
    computed: {
        philhealth_main_filtered() {
            var temp = this.philhealth_summary.filter(item => {
                return (item.fiscalYear==this.selectedFiscalYear)
            })
            if (this.search) {
                temp = temp.filter(item => {
                    return item.monthName.toLowerCase().includes(this.search.toLowerCase())
                })
            }

            // Add computed Status field (Paid / Unpaid)
            temp = temp.map(e => ({
                ...e,
                Status: e.paidOn ? 'Paid' : 'Unpaid'
            }))
            return temp
        },
        fiscal_years() {
            if (this.$store.state.fiscalPeriods) {
                return this.$store.state.fiscalPeriods
            }
            return [{fiscalYear: new Date().getFullYear()}]
        }
    }
}
</script>